import { useEffect, useState } from 'react'
import ReactConfetti from 'react-confetti'

type Props = {
	colors: string[]
	drawShape?: (ctx: CanvasRenderingContext2D) => void
	numberOfPieces?: number
	wind?: number
	opacity?: number
	gravity?: number
}

const ConfettiAnimation = ({
	colors,
	drawShape = undefined,
	numberOfPieces = 200,
	wind = 0,
	opacity = 1,
	gravity = 0.1
}: Props) => {
	const [displayConfetti, setDisplayConfetti] = useState<boolean>(true)

	useEffect(() => {
		const timeout = setTimeout(() => {
			setDisplayConfetti(false)
		}, 500)
		return () => clearTimeout(timeout)
	}, [])

	return (
		<ReactConfetti
			style={{ position: 'fixed', top: 0, left: 0, zIndex: 1000 }}
			gravity={gravity}
			initialVelocityX={2}
			initialVelocityY={2}
			numberOfPieces={numberOfPieces}
			opacity={opacity}
			recycle={displayConfetti}
			drawShape={drawShape}
			run
			wind={wind}
			colors={colors}
		/>
	)
}

export default ConfettiAnimation
